import {
  MENU_CATEGORIES_INIT, MENU_CATEGORIES_CHANGE
} from "../actions/menu_categories_actions";


const initialState = {
  menuCategories: []
};


export const menuCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MENU_CATEGORIES_INIT: {
      return {
        ...state,
        menuCategories: [...action.menuCategories]
      }
    }
    case MENU_CATEGORIES_CHANGE: {
      return {
        ...state,
        menuCategories: [...action.payload]
      }
    }
    default: return state;
  }
}
